import { ActionIcon, Menu, Tooltip, useMantineColorScheme } from "@mantine/core";
import { MSIcon } from "components";
import { useTrans } from "core";
import React from "react";

const langs = {
	ar: {
		label: "عربي",
	},
	en: {
		label: "English",
	},
};
const LanguageSwitcher = () => {
	const { changeLanguage, t, i18n } = useTrans();
	const { colorScheme } = useMantineColorScheme();
	return (
		<Menu shadow="md" width={100}>
			<Menu.Target>
				<Tooltip label={t("drawer.switchLanguage")}>
					<ActionIcon size={36} radius={"md"} variant="subtle" color="secondary">
						<MSIcon name="TranslateVariant" />
					</ActionIcon>
				</Tooltip>
			</Menu.Target>

			<Menu.Dropdown>
				{Object.keys(langs)?.map((lang) => (
					<Menu.Item
						key={lang}
						bg={lang === i18n.language ? (colorScheme === "dark" ? "darkColor.2" : "lightColor.3") : ""}
						onClick={() => changeLanguage(lang)}
					>
						{langs?.[lang]?.label}
					</Menu.Item>
				))}
			</Menu.Dropdown>
		</Menu>
	);
};

export default LanguageSwitcher;
